import { privacyIntroduction, privacySections } from "../data/privacyPolicy.js";
import { openAnalyticsPreferences } from "../lib/analytics.js";

function PolicyText({ text }) {
  return text
    .split(/(hello@karalewich\.com|201-500-5343)/g)
    .map((part, index) =>
      part === "hello@karalewich.com" ? (
        <a href="mailto:hello@karalewich.com" key={index}>
          {part}
        </a>
      ) : part === "201-500-5343" ? (
        <a href="tel:+12015005343" key={index}>
          {part}
        </a>
      ) : (
        part
      ),
    );
}
export default function Privacy() {
  return (
    <main id="main" className="kw-privacy-page">
      <span className="kw-eyebrow">YOUR INFORMATION. YOUR PRIVACY.</span>
      <h1>Privacy Policy.</h1>
      <p className="kw-privacy-intro">
        We are committed to protecting your privacy.
      </p>
      <p>
        <PolicyText text={privacyIntroduction} />
      </p>
      {privacySections.map((section) => (
        <section key={section.title}>
          <h2>{section.title}</h2>
          {section.content.map((block, index) =>
            block.type === "list" ? (
              <ul key={index}>
                {block.items.map((item) => (
                  <li key={item}>
                    <PolicyText text={item} />
                  </li>
                ))}
              </ul>
            ) : (
              <p key={index}>
                <PolicyText text={block.text} />
              </p>
            ),
          )}
        </section>
      ))}
      <section>
        <h2>Website measurement</h2>
        <p>The current website uses first-party, cookieless analytics to understand page visits, navigation, approximate engagement, performance and confirmed inquiry conversions. Temporary visit identifiers stay in memory and reset on reload or after inactivity. No analytics cookies, persistent visitor identifiers, session recordings, form contents or typed questions are collected. Browser family, operating system family and general device type help identify compatibility problems. Global Privacy Control, Do Not Track and your analytics preference are respected.</p>
        <p>Inquiry details are stored separately in our private Firebase backend and delivered by email through Resend. Analytics events expire after 180 days and inquiries after 365 days, subject to asynchronous provider deletion. Hosting and service providers may process request metadata under their own policies.</p>
      </section>
      <div className="kw-policy-preferences">
        <span>Manage optional website analytics.</span>
        <button type="button" onClick={openAnalyticsPreferences}>
          Analytics preferences
        </button>
      </div>
    </main>
  );
}
